/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.UserInfoModel } | undefined) {
  const { currentUser } = initialState ?? {};
  const permissionList = currentUser?.permission?.map(e => e.id) ?? []
  return {
    accountManagement: currentUser && permissionList?.includes(1),
    roleManagement: currentUser && permissionList?.includes(4),
    houseManagement: currentUser && permissionList?.includes(2),
    districtManagement: currentUser && permissionList?.includes(5),
    feedbackManagement: currentUser && permissionList?.includes(3),
  };
}
